import { Controller } from "@hotwired/stimulus";
import { ATTACHMENT_TYPES } from "../../utils/constants";
import { fetchStream } from "../../utils/turbo_utils";
import { urlCollectionParams, toggleClass } from "../../utils/misc";

export default class extends Controller {
  static targets = ["attachmentTypes", "attachInvoicesForm", "attachUnknownAttachmentsForm"];

  attachUnknownAttachmentsFormTargetConnected() {
    toggleClass(this.attachUnknownAttachmentsFormTarget, "hidden", this.attachInvoicesFormTargets.length === 0);
  }

  attachmentTypeChanged(e) {
    if (e.target.value === ATTACHMENT_TYPES.UNKNOWN_ATTACHMENT) {
      this.attachUnknownAttachmentsFormTarget.classList.remove("hidden");
      this.attachInvoicesFormTarget.classList.add("hidden");
    } else {
      this.attachUnknownAttachmentsFormTarget.classList.add("hidden");
      this.attachInvoicesFormTarget.classList.remove("hidden");
    }
  }

  filesAdded() {
    this.attachInvoicesFormTargets.forEach((target) => target.classList.add("hidden"));

    this.attachmentTypesTarget.classList.add("hidden");
  }

  purchaseFilesAdded(e) {
    const { bank_transaction, accountable_ids } = JSON.parse(e.detail[0].response);
    document.dispatchEvent(
      new CustomEvent("bankTransaction:filesAttached", { detail: { bankTransactions: [bank_transaction] } })
    );

    const idParams = urlCollectionParams("ids[]", accountable_ids);
    const url = `${this.attachInvoicesFormTarget.dataset.uploadedPurchasesFormsUrl}&${idParams}`;

    fetchStream(url);
  }
}
